<template>
  <div>
    <el-table
      :data="list"
      style="width: 100%">
      <el-table-column
        prop="order_sn"
        label="订单编号"
        width="210">
      </el-table-column>
      <el-table-column
        prop="task_time"
        label="结束时间"
        width="140">
      </el-table-column>
      <el-table-column
        prop="task_click"
        label="任务点击量"
        width="90">
      </el-table-column>
      <el-table-column
        prop="money"
        label="赏金金额"
        width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.reward_type !== '4'">{{scope.row.money}}</span>
          <span v-if="scope.row.reward_type == '4'">0.00</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="reward_type"
        label="奖励类型"
        width="80">
        <template slot-scope="scope">
          <span v-if="scope.row.reward_type == '0'">赏金</span>
          <span v-if="scope.row.reward_type == '1'">优惠券</span>
          <span v-if="scope.row.reward_type == '2'">体验卡</span>
          <span v-if="scope.row.reward_type == '3'">实物</span>
          <span v-if="scope.row.reward_type == '4'">抽奖次数</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="task_title"
        label="订单标题">
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="120">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row.id,scope.row.task_id)" size="small">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages">
      <el-pagination
              @current-change="current_change"
              :current-page.sync="currentPage"
              :page-size="10"
              layout="prev, pager, next, jumper"
              :total="orderTotal"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import {orderList} from '@/config/api.js'
export default {
  name: 'Tab1',
  data () {
    return {
      list: [],
      orderTotal: 0,
      currentPage: 1
    }
  },
  methods: {
    getOrder () {
      let data = {
        user_type: this.$store.state.user_type,
        page: this.currentPage - 1,
        user_id: this.$store.state.user_id,
        type: 0
      };
      this.$post(orderList ,data)
              .then(res => {
                const data = res.data;
                this.list = data.list;
                this.orderTotal = Number(data.count);
              })
              .catch(err => {
                window.console.log(err)
              })
    },
    current_change (currentPage) {
      this.currentPage = currentPage;
      this.getOrder();
    },
    handleClick (id,task_id) {
      window.console.log(id);
      this.$router.push({path:'/daren/detail' +'?user_id=' + this.$store.state.user_id + '&id=' + id + '&task_id=' + task_id})
    }
  },
  created() {
    this.getOrder();
  }
}
</script>
<style scoped></style>
